import { LogoutStartAction, LOGOUT_START_ACTION } from './types'

export interface LogoutStartActionCreator {
  (): LogoutStartAction
}

export const logoutStartActionCreator: LogoutStartActionCreator = () => ({
  type: LOGOUT_START_ACTION,
})
